<mat-drawer-container class="content-container">
  <mat-drawer class="sidepanel" mode="side" opened>
    <div class="sidebar-brand">
      <div class="brand-mark">ds</div>
      <div class="brand-text">
        <div class="brand-name">datastor.io</div>
        <div class="brand-subtitle">Tenant Registration</div>
      </div>
    </div>

    <div class="sidebar-status">
      <div class="nav-section">{{ sidebarTitle }}</div>
      <p class="status-summary">{{ sidebarSummary }}</p>
    </div>

    <div class="sidebar-footer">
      @if (isLocal) {
      <div class="status-pill">Environment: Local</div>
      <div class="toggle-row">
        <mat-slide-toggle color="primary" [checked]="dryRunEnabled" (change)="setDryRun($event.checked)">
          API dry run
        </mat-slide-toggle>
      </div>
      }
      <div class="status-note">
        Need help?
        <a class="support-link" href="mailto:support@kelyntech.com">Contact support</a>.
      </div>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <div class="page-frame">
      <header class="page-header">
        <h1>Registration</h1>
        <p>Set up your tenant and choose the right Atlas plan.</p>
      </header>

      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>